import { useState, useEffect } from "react";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import UserBaseUtils from "Utility/UserBase.js";
import Modal from "./Modal";
import CreateEvent from "./CreateChurch";
import CreateAnswer from "./CreateAnswer";
import ModalAnswer from "./ModalAnswer";
import StorageKeys from "Utility/StorageKey.js";
import StorageBox from "Store/StorageBox.js";
import ChurchAnimation from "./Church.json";
import Lottie from "lottie-react";
import AxiosWidgetChurch from "./Axios";

const CreateChurchTable = () => {
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [openAnswer, setOpenAnswer] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [editingChurch, setEditingChurch] = useState<any>(null);
  const [editName, setEditName] = useState("");
  const [editIntroduction, setEditIntroduction] = useState("");
  const [currentItem, setCurrentItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
  const [profileImage, setProfileImage] = useState();
  const [showMenu, setShowMenu] = useState<string | null>(null);

  const getData = async () => {
    var user = UserBaseUtils.getProfileUserName();
    var data = await AxiosWidgetChurch.getChurch(user);

    const churchesData = data.data || [];
    setData(churchesData);

    // Store full churches array in StorageBox so ChurchSelector can access it
    if (churchesData.length > 0) {
      StorageBox.inputChurchesArray(churchesData);
    }

    // Sync first church data to StorageBox so ChurchMembers can access it
    if (churchesData.length > 0) {
      const church = churchesData[0];
      // Handle both userPending and UserPending (case sensitivity)
      const userPendingData = church.userPending || church.UserPending || [];
      const userJoinData = church.userJoin || church.UserJoin || [];

      StorageBox.inputChurchDetails({
        name: church.name,
        introduction: church.introduction,
        imagesName: church.imagesName,
        id: church.id,
        personCreate: church.personCreate,
        userJoin: userJoinData,
        userPending: userPendingData,
      });

      console.log("Synced church data to StorageBox:", {
        name: church.name,
        userJoin: userJoinData,
        userPending: userPendingData,
      });

      // Dispatch custom event to notify other components
      window.dispatchEvent(
        new CustomEvent("churchDataUpdated", {
          detail: { churches: churchesData },
        })
      );
    }
  };

  const handleEdit = (church: any) => {
    setEditingChurch(church);
    setEditName(church.name || "");
    setEditIntroduction(church.introduction || "");
    setOpenEdit(true);
    setShowMenu(null);
  };

  const handleEditNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;
    // Convert to lowercase
    value = value.toLowerCase();
    // Remove special characters but keep spaces, letters, and numbers
    value = value.replace(/[^a-z0-9\s]/g, "");
    // Trim whitespace at the beginning and end
    setEditName(value);
  };

  const handleSaveEdit = async () => {
    if (!editingChurch) return;

    // Trim the editName before saving
    const trimmedName = editName.trim();

    const result = await AxiosWidgetChurch.updateChurch(
      editingChurch.name,
      trimmedName,
      editIntroduction
    );

    if (result.success) {
      // Refresh data to get updated church information
      await getData();

      // Get the updated church data to update storage
      const user = UserBaseUtils.getUserName();
      const updatedChurchData = await AxiosWidgetChurch.getChurch(user);

      if (updatedChurchData.data && updatedChurchData.data.length > 0) {
        // Find the updated church (by new name or old name if name didn't change)
        const updatedChurch = updatedChurchData.data.find(
          (church: any) =>
            church.name === trimmedName || church.name === editingChurch.name
        );

        if (updatedChurch) {
          // Update ChurchBase storage with the latest church data
          StorageBox.inputChurchDetails({
            name: updatedChurch.name,
            introduction: updatedChurch.introduction,
            imagesName: updatedChurch.imagesName,
            id: updatedChurch.id,
            personCreate: updatedChurch.personCreate,
            userJoin: updatedChurch.userJoin || [],
            userPending:
              updatedChurch.userPending || updatedChurch.UserPending || [],
          });

          console.log(
            "Updated ChurchBase storage with new church data:",
            updatedChurch.name
          );
        }
      }

      setOpenEdit(false);
      setEditingChurch(null);
      setEditName("");
      setEditIntroduction("");
    } else {
      alert(`Error updating church: ${result.error}`);
    }
  };

  const handleDelete = async (churchName: string) => {
    if (
      !window.confirm(
        `Are you sure you want to delete the church "${churchName}"? This will also delete all related posts.`
      )
    ) {
      return;
    }

    const result = await AxiosWidgetChurch.deleteChurch(churchName);

    if (result.success) {
      // Refresh data
      await getData();
      setShowMenu(null);
    } else {
      alert(`Error deleting church: ${result.error}`);
    }
  };

  const inputData = async (question: { body: string; churchName: string }) => {
    var data = [
      {
        id: "test",
        Question: question.body,
        id_trst: 30,
        likes: "0",
        post_id: "main",
        User: question.churchName,
      },
    ];
    setData((prevData) => [...prevData, ...data]);
  };

  useEffect(() => {
    getData();
  }, []);

  const getAnswerId = () => {
    return currentItem;
  };
  const inputDataAnswer = async (question: {
    body: string;
    user: string;
    currentItem: any;
  }) => {
    var data = [
      {
        body: question.body,
        id_trst: 30,
        likes: "0",
        post_id: "main",
        user_id: question.user,
      },
    ];

    console.log(question);
    console.log("apa sini");

    setData((prevData) => {
      return prevData.map((item) => {
        if (item.id === question.currentItem) {
          return {
            ...item,
            body: question.body,
          };
        }

        return item;
      });
    });
  };

  const columns = [{ key: "Church", label: "Church" }];

  const handleSort = (key: string) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const sortedData = () => {
    if (!sortConfig.key) return data;

    return [...data].sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === "ascending" ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === "ascending" ? 1 : -1;
      }
      return 0;
    });
  };

  const GetprofileImage = (user: string): string => {
    console.log("why is this unchanging");
    console.log(user);
    var item = StorageKeys.SupabaseChurchUrlProfile + user;
    return item;
  };

  const CheckIfProfile = () => {
    var user = UserBaseUtils.getUserName();
    var profile = UserBaseUtils.getProfileUserName();
    if (user == profile) {
      return true;
    } else {
      return false;
    }
  };

  const getSortIcon = (key: string) => {
    if (sortConfig.key !== key) return <FaSort className="ml-2 inline" />;
    if (sortConfig.direction === "ascending")
      return <FaSortUp className="ml-2 inline" />;
    return <FaSortDown className="ml-2 inline" />;
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedData().slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginate = (pageNumber: number) => setCurrentPage(pageNumber);

  return (
    <div className="m-5 p-4  shadow-md">
      <div className="overflow-x-auto">
        <div className="inline-block min-w-full align-middle">
          {data.length === 0 && (
            <div className="mb-4 flex justify-end">
              <button
                className="rounded-lg border border-orange-600 bg-orange-500 px-4 py-2 text-white hover:bg-orange-600"
                onClick={() => setOpen(true)}
              >
                Create Church
              </button>
            </div>
          )}
          <div className="overflow-hidden border-b border-gray-200">
            <div className="">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="sticky top-0">
                  <tr>
                    {columns.map((column) => (
                      <th
                        key={column.key}
                        scope="col"
                        className="cursor-pointer px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500 hover:bg-gray-100"
                        onClick={() => handleSort(column.key)}
                      >
                        {column.label}
                        {getSortIcon(column.key)}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {data && data.length === 0 && (
                    <tr className="">
                      <td className="flex items-center justify-center whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-500">
                        <div className="mr-4 h-48 w-48">
                          <Lottie
                            animationData={ChurchAnimation} // Pass the imported JSON file
                            loop={true} // Set to true to make the animation loop
                            autoplay={true} // Set to true to start the animation automatically
                            style={{ width: "100%", height: "100%" }} // Lottie takes up 100% of its parent div
                          />
                        </div>

                        <h1 className="text-lg font-semibold text-gray-700">
                          There is no Church yet
                        </h1>
                      </td>
                    </tr>
                  )}
                  {currentItems.map((item) => (
                    <tr key={item.id} className="">
                      <td className="whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-500">
                        <>
                          <div className="w-full lg:flex lg:max-w-full ">
                            <div className="flex w-full flex-col justify-between p-4 pb-2 leading-normal">
                              <div className="mb-[.25rem] flex">
                                {" "}
                                {item.name != "anonymous" ? (
                                  <img
                                    src={GetprofileImage(item.imagesName)}
                                    alt="Image"
                                    className="mr-2 h-8 w-8 rounded-full"
                                  />
                                ) : (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke-width="1.5"
                                    stroke="currentColor"
                                    className="mr-2 h-6 w-6 text-gray-400"
                                  >
                                    <path
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
                                    />
                                  </svg>
                                )}
                                {item.name != "anonymous" ? (
                                  <span
                                    className=" pt-2  text-lg leading-none text-gray-200" // Use className for Tailwind classes
                                    style={{ fontSize: "1em" }} // Correct inline style syntax
                                  >
                                    {item.name ?? "unknown"}
                                  </span>
                                ) : (
                                  <span
                                    className="pt-1  text-lg leading-none text-gray-200"
                                    style={{ fontSize: "1em" }}
                                  >
                                    public/Anonymous
                                  </span>
                                )}
                                <div className="relative ml-auto">
                                  <button
                                    onClick={() =>
                                      setShowMenu(
                                        showMenu === item.id ? null : item.id
                                      )
                                    }
                                    className="rounded p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
                                    title="Menu"
                                  >
                                    <svg
                                      className="h-5 w-5"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
                                      />
                                    </svg>
                                  </button>

                                  {/* Dropdown Menu */}
                                  {showMenu === item.id && (
                                    <div className="ring-black absolute right-0 z-50 mt-1 w-40 rounded-md bg-white shadow-lg ring-1 ring-opacity-5">
                                      <div className="py-1">
                                        <button
                                          onClick={() => handleEdit(item)}
                                          className="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                        >
                                          <svg
                                            className="mr-2 h-4 w-4"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                          >
                                            <path
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              strokeWidth={2}
                                              d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                                            />
                                          </svg>
                                          Edit
                                        </button>
                                        <button
                                          onClick={() =>
                                            handleDelete(item.name)
                                          }
                                          className="flex w-full items-center px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
                                        >
                                          <svg
                                            className="mr-2 h-4 w-4"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                          >
                                            <path
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              strokeWidth={2}
                                              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                            />
                                          </svg>
                                          Delete
                                        </button>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="mb-2 flex items-center justify-between whitespace-pre-wrap text-sm font-bold leading-6 text-gray-500">
                                <div></div>
                                {/* Menu Bar */}
                              </div>
                              <div className="mb-8">
                                <div className="mb-2 whitespace-pre-wrap text-sm font-bold leading-6 text-gray-500">
                                  {item.introduction}
                                </div>
                                <p
                                  className="text-sm leading-5 text-gray-700"
                                  style={{ whiteSpace: "pre-line" }}
                                >
                                  {item.body}
                                </p>
                              </div>
                              <div className="flex items-center text-gray-400">
                                <div className="mr-5 text-sm  text-gray-400"></div>
                                <div className="ml-5 contents h-full flex-col justify-between text-right "></div>
                                <div className="flex h-[100%] w-full  flex-col text-right">
                                  <div className="h-inherit"></div>
                                  <div className="flex justify-end justify-items-end">
                                    {item.body != null &&
                                    CheckIfProfile() == true ? (
                                      <div className="flex items-center">
                                        <p
                                          className="mr-2 pt-2 text-sm leading-none text-gray-400"
                                          style={{ fontSize: "1em" }}
                                        >
                                          Answered by:{" "}
                                        </p>
                                        <div className="mb-[.25rem] flex items-center">
                                          <img
                                            src={GetprofileImage(item.Receiver)}
                                            alt="Image"
                                            className="mr-2 h-8 w-8 rounded-full"
                                          />
                                          <a
                                            href={`profile?user=${item.Receiver}`}
                                            className="pt-2 text-sm leading-none text-gray-400"
                                            style={{ fontSize: "1em" }}
                                          >
                                            {item.Receiver ?? "unknown"}
                                          </a>
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <>
        <Modal open={open} onClose={() => setOpen(false)}>
          <CreateEvent
            onClose={() => setOpen(false)}
            inputData={inputData}
          ></CreateEvent>
        </Modal>

        <ModalAnswer open={openAnswer} onClose={() => setOpenAnswer(false)}>
          <CreateAnswer
            onClose={() => setOpenAnswer(false)}
            inputData={inputDataAnswer}
            currentItem={currentItem}
          ></CreateAnswer>
        </ModalAnswer>

        {/* Edit Church Modal */}
        <Modal open={openEdit} onClose={() => setOpenEdit(false)}>
          <div
            className="w-full max-w-lg space-y-5 rounded-xl bg-white p-6 shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-center text-3xl font-extrabold text-gray-800">
              Edit Church
            </h2>

            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Church Name
                </label>
                <input
                  type="text"
                  value={editName}
                  onChange={handleEditNameChange}
                  className="mt-1 block w-full rounded-lg border border-gray-300 p-3 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-4 focus:ring-blue-500/50"
                  placeholder="Church name..."
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Introduction
                </label>
                <textarea
                  value={editIntroduction}
                  onChange={(e) => setEditIntroduction(e.target.value)}
                  className="mt-1 block h-32 w-full resize-none rounded-lg border border-gray-300 p-3 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-4 focus:ring-blue-500/50"
                  placeholder="Church introduction..."
                />
              </div>
            </div>

            <div className="flex justify-end space-x-3">
              <button
                onClick={() => {
                  setOpenEdit(false);
                  setEditingChurch(null);
                  setEditName("");
                  setEditIntroduction("");
                }}
                className="rounded-lg bg-gray-200 px-4 py-2 font-medium text-gray-700 hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                onClick={handleSaveEdit}
                disabled={!editName.trim()}
                className="rounded-lg bg-blue-600 px-4 py-2 font-medium text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50"
              >
                Save
              </button>
            </div>
          </div>
        </Modal>
      </>

      {/* Click outside to close menu */}
      {showMenu && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setShowMenu(null)}
        ></div>
      )}
    </div>
  );
};

export default CreateChurchTable;
